import React from "react";
import toast from "react-hot-toast";
import QuotaToast from "../components/QuotaToast";

/**
 * Show a quota exceeded alert using react-hot-toast (custom toast).
 * Renders a fixed overlay so it stays visible when the page is scrolled.
 * Returns a Promise that resolves when the user clicks OK.
 *
 * @param {string} title - Alert title
 * @param {string} message - Alert message
 * @param {string} buttonText - Button label (e.g. "OK")
 * @param {{ anchor?: HTMLElement|React.RefObject, anchorPosition?: 'above'|'below' }} [options] - If anchor is set, the modal is positioned above (or below) that element.
 */
export function showQuotaExceededAlert(title, message, buttonText, options = {}) {
  return new Promise((resolve) => {
    if (typeof window === "undefined") {
      resolve();
      return;
    }
    try {
      const anchorEl = options?.anchor?.current ?? options?.anchor;
      const anchorPosition = options?.anchorPosition ?? "above";
      let position = null;
      if (anchorEl && typeof anchorEl.getBoundingClientRect === "function") {
        const rect = anchorEl.getBoundingClientRect();
        position = { top: rect.top, left: rect.left + rect.width / 2 };
      }
      toast.custom(
        (t) =>
          React.createElement(QuotaToast, {
            toastId: t.id,
            title,
            message,
            buttonText,
            onDismiss: () => {
              toast.dismiss(t.id);
              resolve();
            },
            position,
            anchorPosition,
          }),
        { duration: Infinity }
      );
    } catch {
      const text = [title, message].filter(Boolean).join("\n\n");
      window.alert(text);
      resolve();
    }
  });
}
